import { Utils } from "@/plugins/utils"

export default {
	namespaced: true,
	state: {
		lstCvf: [],
		cvf: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
	},
	getters: {
		getCvf: state => state.cvf,
		getUpdate: state => state.update,
	},
	mutations: {
		setCvf(state, cvf) {
			state.cvf = cvf
		},
		setLstCvf(state, payload) {
			state.lstCvf = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		async save({ dispatch }, { cvf }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando lista de preços", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.post("/Price/SpecialPriceBySize/Save/", cvf)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{ titleText: "Erro", titleColor: "red", text: error.message },
						{ root: true },
					)
					return null
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async find({ commit, dispatch }, { cvfproduto, cvflista }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Pesquisando", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.get(`/Price/SpecialPriceBySize/Find/${cvfproduto}/${cvflista}`)
				.then(response => {
					let cvf = Utils.ValidateAxiosResponse(response.data)
					commit("setCvf", cvf)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async findList({ commit, dispatch }, { cvfproduto }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Pesquisando", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.get(`/Price/SpecialPriceBySize/FindList/${cvfproduto}`)
				.then(response => {
					let lstCvf = Utils.ValidateAxiosResponse(response.data)
					commit("setLstCvf", lstCvf)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async delete({ dispatch }, { cvfproduto, cvflista }) {
			await this._vm.$axios
				.delete(`/Price/SpecialPriceBySize/Delete/${cvfproduto}/${cvflista}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
		},
		async deleteAll({ dispatch }, oldCvfLst) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo listas de preço removidas", indeterminate: true },
				{ root: true },
			)
			let payload = true
			oldCvfLst.forEach(async cvf => {
				payload = await this._vm.$axios
					.delete(`/Price/SpecialPriceBySize/Delete/${cvf.cvfproduto}/${cvf.cvflista}`)
					.then(response => {
						Utils.ValidateAxiosResponse(response.data)
						return true
					})
					.catch(error => {
						dispatch(
							"parameters/openDialog",
							{
								titleText: "Erro",
								titleColor: "red",
								text: error.message,
							},
							{ root: true },
						)
						return false
					})
			});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
	},
}
